<template>
  <div class="page" @scroll="scrollEvent">
    <div class="signal-qq" onclick="window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true');">
      <img src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/home-signal-qq.jpg" alt="">
    </div>
    <div class="head">
      <Header ref="head" />
    </div>
    <div class="page-content">
      <router-view />
    </div>
    <Footer v-if="footerShow" @setScrollTop="setScrollTop" />
  </div>
</template>

<script>

import Header from "./components/Header"
import Footer from "./components/Footer"
import { whiteList } from "@/api/config"
export default {
  name: "index",
  components: { Header, Footer },
  data () {
    return {
      whiteList,
      footerShow: false
    }
  },
  watch: {
    $route (to) {
      console.log(to.path)
      this.footerShow = whiteList.includes(to.path)
    },
  },
  created () {
    let source = localStorage.getItem('customerSource');
    if(this.getUrlParam("source")){
      source = this.getUrlParam("source")
    }
    localStorage.setItem('customerSource', source)
  },
  mounted () {
    this.footerShow = whiteList.includes(this.$route.path)
  },
  methods: {
    getUrlParam (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      var r = window.location.href.split("?")[1] && window.location.href.split("?")[1].match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      }
      return null//返回参数值
    },
    setScrollTop (num) {
      this.$nextTick(() => {
        let box = document.querySelector(".page")
        box.scrollTop = num
      })
    },
    scrollEvent (e) {
      //  if(e.srcElement.scrollTop > 80){
      //     this.$refs.head.scrollAct = true
      //  }else{
      //     this.$refs.head.scrollAct = false
      //  }
    },
  },
};
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  overflow: auto;
  // overflow-x: hidden;
  background: #f0f3fb;
  .head {
    position: relative;
    z-index: 99;
    height: 60px;
  }
  .page-content {
    overflow: hidden;
  }
  .signal-qq {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    position: fixed;
    right: 60px;
    bottom: 100px;
    z-index: 100;
    cursor: pointer;
    & > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>